import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fields", "select"]

  connect() {
    this.toggle()
  }

  toggle() {
    const enabled = this.selectTarget.value === "1"
    this.fieldsTarget.classList.toggle("hidden", !enabled)
  }
}
